import React from 'react'

import FormRadio from '@f/elements/FormRadio'

const FilterRadio = props => {
  const handleRadio = event => {
    const target = event.target
    const currentParam = `${target.name}__in`
    const defaultValue = props.filter.default

    let params = { ...props.params }

    params[currentParam] = target.value

    if (params[currentParam] === defaultValue) {
      params[currentParam] = ''
    }

    const { lat__range, lon__range, ...paramsWithoutLocation } = params
    props.updateQuery(paramsWithoutLocation)
  }

  return (
    <FormRadio
      name={props.filter.name}
      radioValue={props.option.id}
      theme='basic'
      label={props.option.name}
      className='[ f-c-bo-neu025 ] is-full-width'
      labelClassName='[ f-d-inbl f-t-body f-m-a-005 f-m-l-010 f-c-fo-pri ]'
      onChange={handleRadio}
      defaultChecked={props.option.id == props.filter.currentValue}
      wtData={{
        radiobutton: {
          location: 'filter-panel'
        }
      }}
    />
  )
}

export default FilterRadio
